import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {BottomSheetGenericComponent} from './bottom-sheet-generic.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatListModule } from '@angular/material/list';



@NgModule({
  declarations: [BottomSheetGenericComponent],
  imports: [
    CommonModule,
    MatListModule,
    MatButtonToggleModule
  ],
  exports: [BottomSheetGenericComponent],
})
export class BottomSheetGenericModule { }
